import WebhookList from './List.vue'
import WebhookCreate from './Create.vue';
import WebhookView from './View.vue';
import AppContainer from '@/container/AppContainer.vue';

export const routes = [
    {
        path: '/braze-webhooks',
        name: 'braze',
        component: AppContainer,
        children: [
            {
                path: 'new',
                component: WebhookCreate,
                meta: {
                    title: "New Braze Webhook"
                }
            },
            {
                path: ':id',
                component: WebhookView,
                meta: {
                    title: "Braze Webhook"
                }
            },
            {
                path: '/',
                component: WebhookList,
                meta: {
                    title: "Braze Webhooks"
                }
            }
        ]
    }
]
